import CartItemViewModel from './CartItemViewModel'

const CartItemsViewModel = (cartItems) => cartItems.map(CartItemViewModel)

export default CartItemsViewModel
